import { createSlice } from "@reduxjs/toolkit";
import { AppThunkAction } from "../../../redux-store";
import * as cargoActions from "../../cargo";
import { DateTime } from "luxon";
import { userStorage } from "../../../helpers/user-storage";

// Saved per user and restored once the user is known (see checkAuthState).
export const UPCOMING_PAGE_TEAMS_FILTER = "upcomingPageTeamsFilter";

const prefix = "app/UpcomingPage-page";
type State = {
  open: boolean;
  selectedDate: string;
  filterTeamIds: string[];
};

const initialState: State = {
  open: false,
  selectedDate: DateTime.now().toFormat("yyyy-MM-dd"),
  filterTeamIds: [],
};

export const refresh = (): AppThunkAction => async (dispatch, getState) => {
  const upcomingPageState = getState().app.upcomingPage;
  if (upcomingPageState.open) {
    await dispatch(cargoActions.getCargos(upcomingPageState.selectedDate));
  }
};

export const toggleFilterTeamIdAndSave = (payload: string): AppThunkAction => {
  return async (dispatch, getState) => {
    dispatch(toggleFilterTeamId(payload));
    const state = getState();
    const teamFilterOptions = state.app.upcomingPage.filterTeamIds;
    userStorage.setItem(
      UPCOMING_PAGE_TEAMS_FILTER,
      JSON.stringify(teamFilterOptions)
    );
  };
};

const slice = createSlice({
  initialState,
  name: prefix,
  reducers: {
    setAllFilterTeamIds(state, action) {
      state.filterTeamIds = action.payload;
    },
    toggleFilterTeamId: (state, action) => {
      const teamId = action.payload;
      if (state.filterTeamIds.includes(teamId)) {
        state.filterTeamIds = state.filterTeamIds.filter((id) => id !== teamId);
      } else {
        state.filterTeamIds.push(teamId);
      }
    },
    setSelectedDate(state, action) {
      state.selectedDate = action.payload;
    },
    showUpcomingPage(state) {
      state.open = true;
    },
    hideUpcomingPage(state) {
      state.open = false;
    },
  },
});

export default slice.reducer;
export const {
  showUpcomingPage,
  hideUpcomingPage,
  setSelectedDate,
  toggleFilterTeamId,
  setAllFilterTeamIds,
} = slice.actions;
